<div class="d-flex">
  <div>
    <app-superadminsidenav></app-superadminsidenav>
  </div>
  <div
    style="
      height: 100vh;
      overflow: scroll;
      width: 100%;
      background-color: rgba(250, 250, 250, 1);
    "
  >
    <div class="container">
      <div class="allergens-head">
        <div
          class="allergensBtn"
          [ngClass]="{ bgSelectClass: allergensSlectedFlag }"
          (click)="allergensSelectFunc()"
        >
          Categories
        </div>
        <div
          class="allergensBtn dietaryBtn"
          [ngClass]="{ bgSelectClass: dietarySlectedFlag }"
          (click)="dietarySlectFunc()"
        >
          Cuisines
        </div>
      </div>
      <div class="containerResto" *ngIf="allergensSlectedFlag">
        <div class="container-head">
          <span class="noOfRestoList">{{ lengthCategory }} Categories</span>
          <span class="resto-input">
            <div style="padding: 2px">
              <img src="../../../assets/images/Search.png" alt="" />
              <input
                placeholder="Categories name"
                [(ngModel)]="searchText"
                (ngModelChange)="filter()"
              />
            </div>
          </span>
          <div class="addRestoBtn" (click)="addCategoies()">
            <div>
              <img src="../../../assets/images/Plus.png" alt="" />
              <span>Add categories</span>
            </div>
          </div>
        </div>
        <table
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z8 demo-table"
        >
          <!-- Position Column -->
          <ng-container matColumnDef="SI-NO">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              S.I<br />No.
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              class="table-element"
            >
              {{ i + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="icon">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-head checking categories-icon"
            >
              Categories Icon
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-element categories-icon-element"
            >
              <img
                [src]="element.image"
                alt=""
                style="width: 50px; height: 50px"
              />
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              Categories Name
            </th>
            <td mat-cell *matCellDef="let element" class="table-element">
              {{ element.category_name }}
            </td> 
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              Type
            </th>
            <td mat-cell *matCellDef="let element" class="table-element">
              {{ element.type }}
            </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              Edit
            </th>
            <td mat-cell *matCellDef="let element" class="table-element">
              <img
                src="../../../assets/images/editIcon.png"
                alt=""
                class="edit-element"
                (click)="editDialog(element.category_id)"
              />
            </td>
          </ng-container>

          <!-- Symbol Column -->

          <ng-container matColumnDef="action">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-head action-th checking"
            >
              Action
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-element action-element"
            >
              <img
                src="../../../assets/images/deletIcon.png"
                alt=""
                (click)="openDialog(element.category_id)"
              />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          #paginator
          [pageSizeOptions]="[12, 20, 25]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
      <!-- 2nd part -->
      <div class="containerResto" *ngIf="dietarySlectedFlag">
        <app-cuisines></app-cuisines>
      </div>
    </div>
  </div>
</div>
